import { combineReducers } from 'redux';
import connectionReducer, { Connection } from './slices/connectionsSlice';
import tagReducer from './slices/tagsSlice';
import communityTagReducer from './slices/communityTagsSlice';
import applicationReducer, { ApplicationType } from './slices/applicationSlice';
import adminReducer, { AdminState } from './slices/adminSlice';
import { TagState } from '../types/Tag';
import userReducer, { UserState } from './slices/userSlice';
import eventReducer, { EventState } from './slices/eventSlice';
import formsReducer, { FormsState } from './slices/formsSlice';
import communicationsReducer, { CommunicationsState } from './slices/communicationsSlice';
import postsReducer, { PostsState } from './slices/postsSlice';
import taskReducer, { TasksState } from './slices/tasksSlice';
import financialReducer, { FinancialState } from './slices/financialSlice';
import storageReducer from './slices/storageSlice';

export type RootState = {
  connections: Connection[];
  application: ApplicationType;
  tags: TagState[];
  communityTags: TagState[];
  admins: AdminState;
  user: UserState;
  events: EventState;
  forms: FormsState;
  communications: CommunicationsState;
  posts: PostsState;
  tasks: TasksState;
  financial: FinancialState;
  storage: ReturnType<typeof storageReducer>;
};

const combinedReducer = combineReducers<RootState>({
  connections: connectionReducer,
  tags: tagReducer,
  communityTags: communityTagReducer,
  application: applicationReducer,
  admins: adminReducer,
  user: userReducer,
  events: eventReducer,
  communications: communicationsReducer,
  posts: postsReducer,
  forms: formsReducer,
  tasks: taskReducer,
  financial: financialReducer,
  storage: storageReducer,
});

const rootReducer = (state: any, action: any): any => {
  if (action.type === 'application/logout') {
    localStorage.removeItem('persist:root');
    state = undefined;
  }
  if (action.type === 'application/wipeSelectedCommunity') {
    state.pendingConnections = undefined;
    state.tags = undefined;
    state.communityTags = undefined;
    state = state || {};
    state.connections = undefined;
    state.tags = undefined;
    state.admins = undefined;
    state.events = undefined;
    state.communications = undefined;
    state.posts = undefined;
    state.tasks = undefined;
    state.financial = undefined;
    state.user = undefined;
  }
  if (action.type === 'application/wipeSelectedBusiness') {
    state = state || {};
    state.connections = undefined;
    state.tags = undefined;
    state.communityTags = undefined;
    state.admins = undefined;
    state.events = undefined;
    state.communications = undefined;
    state.posts = undefined;
    state.tasks = undefined;
    state.financial = undefined;
    state.user = undefined;
  }
  const knownKeys = ['connections', 'pendingConnections', 'tags', 'communityTags', 'application', 'admins', 'user', 'events', 'communications', 'tasks', 'financial', 'storage'];
  const filteredState = state ? knownKeys.reduce((acc, key) => {
    if (state[key] !== undefined) {
      acc[key] = state[key];
    }
    return acc;
  }, {} as any) : state;
  return combinedReducer(filteredState, action);
};

export default rootReducer;
